import { Link } from '@tanstack/react-router';
import { useTitle } from '../lib/useTitle';

export default function NotFoundPage() {
  useTitle('Página não encontrada — contabil.dev');
  return (
    <main id="conteudo" className="flex min-h-dvh flex-col items-center justify-center gap-4 px-5" style={{ background: 'var(--app-glow)' }}>
      <p className="font-mono text-app-text-3">404</p>
      <h1 className="text-[22px] font-semibold">Página não encontrada</h1>
      <Link to="/app" className="app-btn app-btn-primary">
        Ir para o painel
      </Link>
    </main>
  );
}
